class FullSlider {
	constructor() {
		this.components = document.querySelectorAll( '.full-slider' );
		this.Splide = window.Splide;

		if ( this.components.length && this.Splide ) {
			this.init();
		}
	}

	init() {
		this.components.forEach( ( component ) => {
			const slider = component.querySelector( '.splide' );
			const slides = slider?.querySelectorAll( '.splide__slide' );

			if (
				! slider ||
				! slides?.length ||
				slider.classList.contains( 'is-initialized' )
			) {
				return;
			}

			component.classList.toggle( 'has-single-slide', slides.length < 2 );

			new this.Splide( slider, {
				type: 'slide',
				rewind: true,
				perPage: 1,
				perMove: 1,
				gap: '2rem',
				arrows: slides.length > 1,
				pagination: false,
				drag: slides.length > 1,
			} ).mount();
		} );
	}
}

new FullSlider();
